import { FormattedMessage } from "react-intl";

import { Container, Row } from "common/core/responsive";
import { Heading, Substyle } from "common/core/typography";
import Icon from "common/core/icon";
import Tooltip from "common/core/tooltip";

import { Col } from "..";
import type { IdentityDetails_documentBundle_DocumentBundle_organizationTransaction_customerSigners as TransactionCustomer } from "../index.query.graphql";
import Styles from "../index.module.scss";
import EmailAge from "./email_age";
import MatchesIdentity from "./matches_identity";
import OverallRiskLevel from "./overall_risk_level";
import SeenBefore from "./seen_before";

export default function EmailRiskSection({
  customer: { emailRiskSignal },
}: {
  customer: TransactionCustomer;
}): React.ReactElement {
  return (
    <dl>
      <Container fluid noSpacing className={Styles.phoneRisk}>
        <Heading className={Styles.sectionHeader} textStyle="subtitleSmall" level="h3">
          <Icon name="email" />
          <FormattedMessage
            id="e938b4ca-794e-4a82-b835-f6f3d2dd8488"
            defaultMessage="Email risk signals"
          />
        </Heading>
        <Row>
          <Col>
            <dt>
              <Substyle className={Styles.phoneRiskTooltipWrapper} textColor="subtle" size="small">
                <FormattedMessage
                  id="4f3a6955-793e-43d7-9fbf-0b76489a912a"
                  defaultMessage="Overall email risk"
                />
                <Tooltip
                  target={
                    <Substyle textColor="subtle">
                      <Icon name="faq" />
                    </Substyle>
                  }
                  placement="rightTop"
                >
                  <FormattedMessage
                    id="ddc03c02-31e1-4116-a607-06d0c5355e6e"
                    defaultMessage="Email risk signal score, ranging from high to low"
                  />
                </Tooltip>
              </Substyle>
            </dt>
            <dd>
              <Substyle size="defaultSize">
                <OverallRiskLevel riskLevel={emailRiskSignal?.overallRiskLevel} />
              </Substyle>
            </dd>
          </Col>
          <Col>
            <dt>
              <Substyle className={Styles.phoneRiskTooltipWrapper} textColor="subtle" size="small">
                <FormattedMessage
                  id="e0d91089-dd74-40e9-b2e6-2a627242ced9"
                  defaultMessage="Seen on network"
                />
                <Tooltip
                  target={
                    <Substyle textColor="subtle">
                      <Icon name="faq" />
                    </Substyle>
                  }
                  placement="rightTop"
                >
                  <FormattedMessage
                    id="85c306bf-b3e9-4038-874c-2837256ee9f3"
                    defaultMessage="Previously seen email address on our network"
                  />
                </Tooltip>
              </Substyle>
            </dt>
            <dd>
              <Substyle size="defaultSize">
                <SeenBefore seenBefore={emailRiskSignal?.seenBefore} />
              </Substyle>
            </dd>
          </Col>
          <Col>
            <dt>
              <Substyle className={Styles.phoneRiskTooltipWrapper} textColor="subtle" size="small">
                <FormattedMessage
                  id="1e7df3d9-db01-4835-ae70-037d49765334"
                  defaultMessage="Email age"
                />
              </Substyle>
            </dt>
            <dd>
              <Substyle size="defaultSize">
                <EmailAge emailAge={emailRiskSignal?.emailAge} />
              </Substyle>
            </dd>
          </Col>
          <Col>
            <dt>
              <Substyle className={Styles.phoneRiskTooltipWrapper} textColor="subtle" size="small">
                <FormattedMessage
                  id="f2d015a1-79da-402a-bc3d-0aae683d5f30"
                  defaultMessage="Matches identity"
                />
                <Tooltip
                  target={
                    <Substyle textColor="subtle">
                      <Icon name="faq" />
                    </Substyle>
                  }
                  placement="rightTop"
                >
                  <FormattedMessage
                    id="25442c69-adab-4f2a-be35-22904e93955b"
                    defaultMessage="Identity is associated with this email address"
                  />
                </Tooltip>
              </Substyle>
            </dt>
            <dd>
              <Substyle size="defaultSize">
                <MatchesIdentity matchesIdentity={emailRiskSignal?.matchesIdentity} />
              </Substyle>
            </dd>
          </Col>
        </Row>
      </Container>
    </dl>
  );
}
